module.exports = __webpack_public_path__ + "static/media/Instagram_Icon.2819bef4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/footer/Instagram_Icon.png
// module id = 1559
// module chunks = 0